import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Cancel from "../../Icons/Cancel";
import { addCommas } from "../../../utils/utils";
import { isEnabledExportExecutiveList, getMaxExportCount } from "../../../utils/planUtils";

const styles = () => ({
  root: {
    padding: "20px",
    background: "#F2F6FF",
    justifyContent: "space-between",
    boxShadow: "0px 3px 6px #0000001A",
    marginBottom: "10px",
    top: 0,
    left: 0,
    width: "100%",
    boxSizing: "border-box",
    position: "sticky",
    zIndex: 2,
  },
});

const ExportCountNoticePanel = ({
  classes,
  user,
  showExportCountNotice,
  onToggleExportCountNotice,
}) => {
  if (!user || !isEnabledExportExecutiveList(user) || !showExportCountNotice) {
    return null;
  }

  const maxExportCount = getMaxExportCount(user);

  return (
    <div
      className={classes.root}
      onClick={onToggleExportCountNotice}
      style={{
        display: "flex",
        top: 0,
      }}
    >
      <Typography
        variant="subheading"
        style={{ fontWeight: "bold", color: "#1A65FF", margin: "auto" }}
      >
        総ダウンロード件数は{addCommas(user.total_export_count)}件、
        現在のプランのダウンロード件数は{addCommas(user.active_plan_export_count)}
        {maxExportCount < Infinity ? `/${addCommas(maxExportCount)}` : ""}
        件です
      </Typography>
      <Cancel width={24} height={24} color={"#6398FF"} />
    </div>
  );
};

ExportCountNoticePanel.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  showExportCountNotice: PropTypes.bool.isRequired,
  onToggleExportCountNotice: PropTypes.func.isRequired,
};

export default withStyles(styles)(ExportCountNoticePanel);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/panels/ExportCountNoticePanel.jsx